import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { APIConsentService } from '../../_services/consent/API-consent';

@Component({
	selector: 'consent-acquisition',
	templateUrl: './consent-acquisition.component.html',
	styleUrls: ['./consent-acquisition.component.css']
})
export class ConsentAcquisitionComponent implements OnInit {

	acquisitionForm: any;
	cs_content: any;
	displayonVerify = "false"
	PEName: any;
	TemplateID: any;
	EntityID: any;
	isValid: boolean = false;
	isSubmitted: boolean = false;
	mobile_number: number;
	cstemplate_id: number;
	submitted = false;
	cstempids = [];
	constructor(private fb: FormBuilder,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private modalService: BsModalService,
		private cst: APIConsentService,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.PEName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
			this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
		});
	}
	get f() { return this.acquisitionForm.controls; }


	ngOnInit() {
		this.acquisitionForm = this.fb.group({
			pe_name: ['',],
			cstemplate_id: ['', [Validators.required]],
			cstemplate_id1: ['', [Validators.maxLength(19), Validators.minLength(19)]],
			mobile_number: ['',[Validators.required, Validators.pattern("[6-9]{1}[0-9]{9}")]],
			consentcontent: ['', [Validators.required]],

		});

		this.acquisitionForm.controls['pe_name'].setValue(this.PEName);
		let data = {
			entity_id: this.EntityID
		}		
		this.cst.fetchCSTID(data).subscribe((res) => {
						
			if (res.status == "success") {
				this.cstempids = res.data
				console.log("--------------", res.data, res.data[0].cstemplate_id, res.data.length)
				this.cstempids.push({ cstemplate_id: 'Others' })
				console.log("this.cstempids", this.cstempids)
				this.isSubmitted = true;
			}
			else {
				console.log("------hi",res.message)
				this.$modal.errorModal({
					title: 'Consent Acquisition',
					msg:  res.message
				})
				this.isValid = true;
			}
		})
	
	}

	verifyCST() {

		let data = {}
		let cstempid = this.acquisitionForm.get('cstemplate_id').value

		if (cstempid != 'Others') {
			data = {
				cst_id: cstempid,
				entity_id: this.EntityID
			}
		}
		else {
			data = {
				cst_id: this.acquisitionForm.get('cstemplate_id1').value,
				entity_id: this.EntityID
			}
		}

		this.cst.verifyCstID(data)
			.subscribe(r => {
				if (r.status == "success") {
					this.displayonVerify = "true";
					this.isValid = true
					this.cs_content = r.data[0].cst_content;
					this.$modal.successModal({
						title: 'Consent Acquisition',
						msg: 'Verified successfully'
					});
				}
				else {
					this.cs_content = "";
					this.$modal.errorModal({
						title: 'Consent Acquisition',
						msg: r.message
					});

				}
			})
	}

	reset(){
		this.acquisitionForm.controls['mobile_number'].reset();
		//this.mobile_number = true;

	}

	//for Form submition
	onSubmit() {

		this.submitted = true;
		if(this.acquisitionForm.invalid)
		{
			console.log(this.acquisitionForm)
			return
		}

		if (this.displayonVerify == "true") {
			let data = {}
			let cstempid = this.acquisitionForm.get('cstemplate_id').value

			if (cstempid != 'Others') {
				data = {
					msisdn: this.acquisitionForm.get("mobile_number").value,
					entityid: this.EntityID,
					constempid: cstempid,
					source: "1"
				}
			}
			else {
				data = {
					msisdn: this.acquisitionForm.get("mobile_number").value,
					entityid: this.EntityID,
					constempid: this.acquisitionForm.get('cstemplate_id1').value,
					source: "1"
				}
			}

			this.cst.acquireCSRegthruPage(data)
				.subscribe(r => {
					console.log("---------------", r.status)
					if (r.status == "200") {
						this.$modal.successModal({
							title: ' Consent Acquisition ',
							msg: 'Consent Acquisition Page Submitted successfully'
						})
						this.isSubmitted = true;
					}
					else {

						this.$modal.errorModal({
							title: 'Consent Acquisition',
							msg: r.status + ' ' + r.message
						})
					}

				})
		}

		else {
			this.$modal.errorModal({
				title: 'Consent Acquisition',
				msg: "Cannot submit request without verification"
			});

		}

	}
}